// extracted by mini-css-extract-plugin
module.exports = {"donationPrompts":"jgp-1GDi1","disabled":"jgp-2G78i","row":"jgp-3riAO","goarrow":"jgp-2NCSs","amount":"jgp-3YQ1x","message":"jgp-22yS_"};